// グローバルスコープでフラグを定義
var pageInitialized = false;

window.addEventListener("load", function () {
  // フラグがtrueなら、すでに初期化済みなので何もしない
  if (pageInitialized) return;

  // 初期化処理を実行
  pageInitialized = true;
  // グローバル変数を利用してデータを取得
  var productVariants = window.myProductVariants || {};
  var variantMetafields = window.myVariantMetafields || {};

  //  console.log("multi-productVariants:", productVariants);
  //  console.log("multi-variantMetafields:", variantMetafields);

  // マッピング処理
  Object.keys(productVariants).forEach(function (variantId) {
    var variant = productVariants[variantId];
    var metafields = variantMetafields[variantId] || {};
    variant.metafields = metafields;
  });

  var optionButtons = document.querySelectorAll(
    'input[name^="template--"][name$="入り数-option"]'
  );

  // 選択されたバリエーションを取得する関数
  function SelectedVariant(selectedValue) {
    //    console.log("multi-SelectedVariant : called.");
    return Object.values(productVariants).find(
      (variant) => variant.option1 === selectedValue
    );
  }

  // 価格を計算する関数
  function calculatePrices(selectedVariant) {
    //    console.log("multi-calculatePrices : called.");
    //    console.log("multi-selectedVariant:", selectedVariant);
    try {
      var salePrice = 0;
      var variantPrice = 0;
      var metafields_price = 0;
      var regularPrice = 0;
      var minSalePrice = 0;

      // セント単位を日本円に変換（100で割る）
      if (selectedVariant.price) {
        variantPrice =
          Math.round(parseInt(selectedVariant.price, 10) / 100) || 0;
      }

      if (
        selectedVariant.metafields &&
        selectedVariant.metafields.metafields_price
      ) {
        metafields_price =
          Math.round(
            parseInt(selectedVariant.metafields.metafields_price, 10) / 100
          ) || 0;
      }

      if (metafields_price > 0) {
        salePrice = metafields_price;
        regularPrice = variantPrice;
      } else {
        salePrice = variantPrice;
        regularPrice = 0;
      }

      if (!isNaN(selectedVariant.option1) && selectedVariant.option1 > 0) {
        minSalePrice = (salePrice / selectedVariant.option1).toFixed(1);
        minSalePrice = parseFloat(minSalePrice);
      } else {
        minSalePrice = 0;
      }

      updatePlaceholders(regularPrice, minSalePrice);
    } catch (error) {
      console.error("multi-calculating err:", error);
    }
  }

  function updatePlaceholders(regularPrice, minSalePrice) {
    //    console.log("multi-updatePlaceholders : called.");
    console.log("multi-regularPrice:", regularPrice);
    console.log("multi-minSalePrice:", minSalePrice);
    // プレースホルダーの更新処理
    var regularPricePlaceholder = document.getElementById(
      "regular-price-placeholder"
    );
    if (regularPricePlaceholder) {
      if (regularPrice > 0) {
        document.getElementById("regular-price-placeholder").textContent =
          regularPrice === 0 ? "" : `¥${regularPrice.toLocaleString("ja-JP")}`;
      }
    }
    document.getElementById("min-sale-price-placeholder").textContent =
      minSalePrice === 0 ? "" : `¥${minSalePrice.toFixed(1)}`;
  }

  // 初期表示処理
  function initializePage() {
    console.log("initializePage : called.");
    var firstOptionButton = optionButtons[0];
    if (firstOptionButton) {
      firstOptionButton.checked = true;
      var selectedValue = firstOptionButton.value;
      var selectedVariant = SelectedVariant(selectedValue);
      if (selectedVariant) {
        calculatePrices(selectedVariant);
      }
    }
  }

  // バリエーションボタンの変更イベント処理
  Array.from(optionButtons).forEach(function (button) {
    button.addEventListener("change", function () {
      var selectedValue = button.value;
      var selectedVariant = SelectedVariant(selectedValue);
      if (selectedVariant) {
        calculatePrices(selectedVariant);
      }
    });
  });

  // 初期表示時にページを初期化
  initializePage();
});
